module.exports = __webpack_public_path__ + "img/ИФ-1(А)-011.e9fce64f.png";